// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".establishment-selector{display:flex;flex-grow:1;overflow-y:hidden}.establishment-selector .establishment-map{flex-basis:66%;height:800px}.establishment-selector .establishment-selector-list{flex-basis:33%;padding-right:1em;border-right:2px solid #cacaca}.establishment-selector .establishment-selector-preview{flex-grow:1}", ""]);
// Exports
module.exports = exports;
